import shopPermissions from "@/Modules/Shop/constants/permissions";

const GLOBAL_TRUE = null;

const TEAM_SPECIFIC = Array.from(
  new Set(
    Object.values(shopPermissions)
      .flatMap((group) => Object.values(group))
      .filter(
        (permission) =>
          permission &&
          permission !== shopPermissions.SHOP.CREATE &&
          permission !== shopPermissions.STORE.CREATE
      )
  )
);

export default {
  GLOBAL_TRUE,
  TEAM_SPECIFIC,
  ...shopPermissions,

  VIEW_DASHBOARD: '',
  VIEW_STATISTIC: 'statistic_view',
  VIEW_USER_PROFILE: null,


  CREATE_CONTACT: 'contact_create',
  VIEW_CONTACT: 'contact_view',
  UPDATE_CONTACT: 'contact_update',
  DELETE_CONTACT: 'contact_delete',
  CONTACT_IMPORT: 'contact_import',
  CONTACT_EXPORT: 'contact_export',

  CREATE_TAX: 'taxe_create',
  VIEW_TAX : 'taxe_view',
  UPDATE_TAX: 'taxe_update',
  DELETE_TAX: 'taxe_delete',

  CREATE_POST_OFFICE: 'post_office_create',
  VIEW_POST_OFFICE: 'post_office_view',
  UPDATE_POST_OFFICE: 'post_office_update',
  DELETE_POST_OFFICE: 'post_office_delete',

  CREATE_ATTRIBUT: 'attribut_create',
  VIEW_ATTRIBUT: 'attribut_view',
  UPDATE_ATTRIBUT: 'attribut_update',
  DELETE_ATTRIBUT: 'attribut_delete',

  CREATE_BRAND: 'brand_create',
  VIEW_BRAND: 'brand_view',
  UPDATE_BRAND: 'brand_update',
  DELETE_BRAND: 'brand_delete',

  CREATE_CATEGORY: 'category_create',
  VIEW_CATEGORY: 'category_view',
  UPDATE_CATEGORY: 'category_update',
  DELETE_CATEGORY: 'category_delete',

  CREATE_PRODUCT: 'product_create',
  VIEW_PRODUCT: 'product_view',
  UPDATE_PRODUCT: 'product_update',
  DELETE_PRODUCT: 'product_delete',
  IMPORT_PRODUCT: 'product_import',
  EXPORT_PRODUCT: 'product_export',

  CREATE_LOT: 'lot_create',
  VIEW_LOT: 'lot_view',
  UPDATE_LOT: 'lot_update',
  DELETE_LOT: 'lot_delete',

  CREATE_BUNDLE: 'bundle_create',
  VIEW_BUNDLE: 'bundle_view',
  UPDATE_BUNDLE: 'bundle_update',
  DELETE_BUNDLE: 'bundle_delete',

  CREATE_VARIATION: 'variation_create',
  VIEW_VARIATION: 'variation_view',
  UPDATE_VARIATION: 'variation_update',
  DELETE_VARIATION: 'variation_delete',

  CREATE_PAYMENT_TYPE: 'payment_type_create',
  VIEW_PAYMENT_TYPE: 'payment_type_view',
  UPDATE_PAYMENT_TYPE: 'payment_type_update',
  DELETE_PAYMENT_TYPE: 'payment_type_delete',

  CREATE_PROFILE: 'profiles_create',
  VIEW_PROFILE: 'profiles_view',
  UPDATE_PROFILE: 'profiles_update',
  DELETE_PROFILE: 'profiles_delete',

  CREATE_USER: 'users_create',
  VIEW_USER: 'users_view',
  VIEW_ALL_USER: 'users_view_all',
  UPDATE_USER: 'users_update',
  UPDATE_ALL_USER: 'users_update_all',
  DELETE_USER: 'users_delete',
  DELETE_ALL_USER: 'users_delete_all',
  IMPORT_USER: 'users_import',
  EXPORT_USER: 'users_export',
  USER_PERMISSION: 'users_permission',

  CREATE_RIGHT: 'right_create',
  VIEW_RIGHT: 'right_view',
  UPDATE_RIGHT: 'right_update',
  DELETE_RIGHT: 'right_delete',
  RIGHT_PERMISSION: 'right_permission_view',

  VIEW_DEPARTMENT: 'department_view',
  CREATE_DEPARTMENT: 'department_create',
  UPDATE_DEPARTMENT: 'department_update',
  DELETE_DEPARTMENT: 'department_delete',


  VIEW_SETTINGS :  ['taxe_view','users_view','right_view','department_view','reason_view',
    'opportunity_state_view','type_activity_view','appointment_type_view','payment_type_view',
    'payment_condition_view','email_message_view','smtp_view','post_office_view','tag_view'
  ],
  VIEW_GENERAL_SETTINGS :  [ 'company_view','taxe_view','users_view','right_view','department_view',
    'payment_type_view', 'payment_condition_view','email_message_view','smtp_view',
    null,'post_office_view',
  ],
  COMPANY_SETTING : [null,'taxe_view','department_view','post_office_view'],
  MULTI_COMPANY_SETTING : ['company_view','company_view','email_message_view', 'smtp_view'],
  USER_SETTING: ['users_view', 'right_view'],
  SYSTEM_SETTING: [ 'payment_type_view', 'payment_condition_view','email_message_view','smtp_view',null],
  VIEW_CRM_SETTINGS :  [ 'reason_view', 'opportunity_state_view','type_activity_view','appointment_type_view','tag_view'],
  VIEW_PIPELINE_SETTINGS :  [ 'reason_view', 'opportunity_state_view','type_activity_view','tag_view'],
  VIEW_APPOINTMENT_SETTINGS :  ['appointment_type_view'],
  VIEW_CRM :  ['opportunities_view','opportunities_view_all','estimate_view','estimate_view_all', 'appointment_view','appointment_view_all',
    'payment_view', 'payment_view_all', 'appointment_view_stats', 'opportunities_stats', 'appointment_view_stats',
    'estimate_view_stats'
  ],
  VIEW_FINANCE : [
    'account_view', 'box_view', 'expense_approved', 'expense_validate', 'expense_approved', 'expense_pay'
  ],
  VIEW_DOCUMENT : 'file_manager_view',
  VIEW_RH : ['holiday_view', 'payslips_view', 'employee_contract_view'],
  VIEW_FINANCE_SETTINGS: ['reason_view', 'expense_recurrence_view'],
  VIEW_EXPENSE_SETTINGS: ['reason_view', 'expense_recurrence_view'],
  VIEW_RH_SETTINGS: ['pension_view', 'allowance_view', 'other_view', 'payroll_tax_view'],
  VIEW_PAYSLIP_SETTINGS: ['pension_view', 'allowance_view', 'other_view', 'payroll_tax_view'],
  VIEW_PROJECT_SETTINGS : ['view_categories','view_milestone', 'create_milestone','create_milestone','update_milestone','delete_milestone','view_column','create_column','update_column','delete_column',
    'view_priority','create_priority', 'update_priority', 'delete_priority', 'view_categories', 'create_categories', 'update_categories','delete_categories'
  ],
  VIEW_QVCT_SURVEY_SETTINGS : ['view_qvct_survey_category'],
  VIEW_EVENT_SETTINGS : ['event_view', 'event_view_all'],
  ADMIN: 'Admin',

  VIEW_EXPENSE: 'expense_view',
  UPDATE_EXPENSE: 'expense_update',
  DELETE_EXPENSE: 'expense_delete',
  PAID_EXPENSE: 'expense_pay',
  SEND_EXPENSE: 'expense_send',
  VIEW_STATS_EXPENSE: 'expense_view_stats',
  DOWNLOAD_EXPENSE: 'expense_download',
  VALIDATE_EXPENSE: 'expense_validate',
  APPROVED_EXPENSE : 'expense_approved',
  REJECT_EXPENSE : 'expense_approved',

  CREATE_EXPENSE_REPORT : 'expense_create_report',
  CREATE_EXPENSE_OFFICE : 'expense_create_office',
  VIEW_OFFICE_EXPENSE : 'view_office_expense',


  VIEW_EXPENSE_REASON : 'expense_reason_view',
  CREATE_EXPENSE_REASON : 'expense_reason_create',
  UPDATE_EXPENSE_REASON : 'expense_reason_update',
  DELETE_EXPENSE_REASON : 'expense_reason_delete',

  VIEW_EXPENSE_TYPE : 'expense_type_view',


  VIEW_EXPENSE_RECURRING : 'expense_recurrence_view',
  CREATE_EXPENSE_RECURRING : 'expense_recurrence_create',
  UPDATE_EXPENSE_RECURRING : 'expense_recurrence_update',
  DISABLE_EXPENSE_RECURRING : 'expense_recurrence_disable',
  ACTIVATE_EXPENSE_RECURRING : 'expense_recurrence_active',

  CREATE_ACCOUNT: 'account_create',
  VIEW_ACCOUNT: 'account_view',
  UPDATE_ACCOUNT: 'account_update',
  DELETE_ACCOUNT: 'account_delete',
  DEPOSIT_ACCOUNT: 'account_deposit',
  WITHDRAWAL_ACCOUNT: 'account_withdrawal',
  TRANSFER_ACCOUNT: 'account_transfer',
  VIEW_STAT_ACCOUNT: 'account_view_stats',

  CREATE_BOX: 'box_create',
  VIEW_BOX: 'box_view',
  UPDATE_BOX: 'box_update',
  DELETE_BOX: 'box_delete',
  DEPOSIT_BOX: 'box_deposit',
  WITHDRAWAL_BOX: 'box_withdrawal',
  TRANSFER_BOX: 'box_transfer',
  VIEW_STAT_BOX: 'box_view_stats',

  CREATE_HOLIDAY: 'holiday_create',
  VIEW_HOLIDAY: 'holiday_view',
  UPDATE_HOLIDAY: 'holiday_update',
  DELETE_HOLIDAY: 'holiday_delete',
  APPROVE_HOLIDAY: 'holiday_approve',
  VALIDATE_HOLIDAY: 'holiday_validate',
  VIEW_STAT_HOLIDAY: 'holiday_view_stats',
  REJECT_HOLIDAY: 'holiday_reject',
  CANCELLED_HOLIDAY : 'holiday_cancelled',

  CREATE_PUBLIC_HOLIDAY: 'public_holiday_view',
  VIEW_PUBLIC_HOLIDAY: 'public_holiday_create',
  UPDATE_PUBLIC_HOLIDAY: 'public_holiday_update',
  DELETE_PUBLIC_HOLIDAY: 'public_holiday_delete',

  CREATE_HOLIDAY_TYPE: 'holiday_type_view',
  VIEW_HOLIDAY_TYPE: 'holiday_type_create',
  UPDATE_HOLIDAY_TYPE: 'holiday_type_update',
  DELETE_HOLIDAY_TYPE: 'holiday_type_delete',

  VIEW_COMPANY: 'company_view',
  CREATE_COMPANY: 'company_create',
  UPDATE_COMPANY: 'company_update',
  DELETE_COMPANY: 'company_delete',

  CREATE_OFFICE: 'office_create',
  VIEW_OFFICE: 'office_view',
  UPDATE_OFFICE: 'office_update',
  DELETE_OFFICE: 'office_delete',


  VIEW_PAYSLIP : 'payslips_view',
  CREATE_PAYSLIP : 'payslips_create',
  UPDATE_PAYSLIP : 'payslips_update',
  DELETE_PAYSLIP : 'payslips_delete',
  SEND_PAYSLIP : 'payslips_send',
  VALIDATE_PAYSLIP : 'payslips_validate',
  DOWNLOAD_PAYSLIP  : 'download_payslip',
  GENERATE_PAYSLIP  : 'generate_payslip',


  VIEW_ALLOWANCE : 'allowance_view',
  CREATE_ALLOWANCE : 'allowance_create',
  UPDATE_ALLOWANCE : 'allowance_update',
  DELETE_ALLOWANCE : 'allowance_delete',

  VIEW_OTHER : 'other_view',
  CREATE_OTHER : 'other_create',
  UPDATE_OTHER : 'other_update',
  DELETE_OTHER : 'other_delete',

   VIEW_PAYROLL_TAX : 'payroll_tax_view',
   CREATE_PAYROLL_TAX : 'payroll_tax_create',
   UPDATE_PAYROLL_TAX : 'payroll_tax_update',
   DELETE_PAYROLL_TAX : 'payroll_tax_delete',


   VIEW_PENSION : 'pension_view',
   CREATE_PENSION : 'pension_create',
   UPDATE_PENSION : 'pension_update',
   DELETE_PENSION : 'pension_delete',

  
  
   VIEW_EMPLOYEE_CONTRACT : 'employee_contract_view',
   CREATE_EMPLOYEE_CONTRACT : 'employee_contract_create',
   UPDATE_EMPLOYEE_CONTRACT : 'employee_contract_update',
   DELETE_EMPLOYEE_CONTRACT : 'employee_contract_delete',
   STORE_FILE_EMPLOYEE_CONTRACT : 'employee_contract_store_file',
   DOWNLOAD_CONTRACT_EMPLOYEE_CONTRACT : 'employee_contract_download',
   DOWNLOAD_PAYSLIP_EMPLOYEE_CONTRACT : 'employee_contract_download_payslip',


    VIEW_EMPLOYEE : 'employee_view',
    CREATE_EMPLOYEE : 'employee_create',
    UPDATE_EMPLOYEE : 'employee_update',
    DELETE_EMPLOYEE : 'employee_delete',

    VIEW_POST_CATEGORY : 'post_category_view',
    CREATE_POST_CATEGORY : 'post_category_create',
    UPDATE_POST_CATEGORY : 'post_category_update',
    DELETE_POST_CATEGORY : 'post_category_delete',


    VIEW_NORMALIZED_KEY : 'normalized_key_view',
    CREATE_NORMALIZED_KEY : 'normalized_key_create',
    UPDATE_NORMALIZED_KEY : 'normalized_key_update',
    DELETE_NORMALIZED_KEY : 'normalized_key_delete',

   VIEW_NPS : 'nps_view',
   CREATE_NPS : 'nps_create',
   UPDATE_NPS : 'nps_update',
   DELETE_NPS : 'nps_delete',
   SEND_NPS : 'nps_send',
   NPS_STATISTIC : 'nps_statistic',
   VIEW_STATISTIC_NPS : 'nps_view_statistic',

  VIEW_PROJECT: 'project_view',
  CREATE_PROJECT: 'project_create',
  UPDATE_PROJECT: 'project_update',
  DELETE_PROJECT: 'project_delete',
  STATS_PROJECT: 'project_stats',
  REPORT_PROJECT: 'project_reports',

  VIEW_USER_PERFORMANCE : 'view_user_performance',

  STEP_PROJECT_VIEW: 'project_view_step',
  STEP_PROJECT_CREATE: 'project_create_step',
  STEP_PROJECT_UPDATE: 'project_update_step',
  STEP_PROJECT_DELETE: 'project_delete_step',

  TASK_PROJECT_VIEW: 'project_view_task',
  TASK_PROJECT_CREATE: 'project_create_task',
  TASK_PROJECT_UPDATE: 'project_update_task',
  TASK_PROJECT_DELETE: 'project_delete_task',
  TASK_PROJECT_CLOSE: 'project_close_task',


  FOLDER_PROJECT_VIEW: 'project_view_folder',
  FOLDER_PROJECT_CREATE: 'project_create_folder',
  FOLDER_PROJECT_UPDATE: 'project_update_folder',
  FOLDER_PROJECT_DELETE: 'project_delete_folder',

  ADD_PROJECT_USER: 'project_add_user',
  SEND_PROJECT_COMMENT: 'project_send_comment',
  CREATE_PROJECT_CATEGORY: 'view_categories',

  VIEW_MILESTONE: 'view_milestone',
  CREATE_MILESTONE: 'create_milestone',
  UPDATE_MILESTONE: 'update_milestone',
  DELETE_MILESTONE: 'delete_milestone',

  VIEW_COLUMN: 'view_column',
  CREATE_COLUMN: 'create_column',
  UPDATE_COLUMN: 'update_column',
  DELETE_COLUMN: 'delete_column',

  VIEW_PRIORITY: 'view_priority',
  CREATE_PRIORITY: 'create_priority',
  UPDATE_PRIORITY: 'update_priority',
  DELETE_PRIORITY: 'delete_priority',

  VIEW_CATEGORIES: 'view_categories',
  CREATE_CATEGORIES: 'create_categories',
  UPDATE_CATEGORIES: 'update_categories',
  DELETE_CATEGORIES: 'delete_categories', 

  PROJECT_BUDGET_VIEW: 'project_budget_view',
  PROJECT_BUDGET_CREATE: 'project_budget_create',
  PROJECT_BUDGET_ALLOCATE: 'project_budget_allocate',
  PROJECT_BUDGET_HISTORIE_TRANSACTION: 'project_budget_history_transaction',
  PROJECT_BUDGET_DEPOSIT: 'project_budget_deposits',
  PROJECT_BUDGET_WITHDRAWAL: 'project_budget_withdrawal',
  PROJECT_BUDGET_STATISTIC: 'project_budget_statistics',
  PROJECT_BUDGET_TRANSACTION_VIEW: 'project_budget_transaction_view',

  PROJECT_REPORTING_VIEW: 'project_reporting_view',
  PROJECT_REPORTING_CREATE: 'project_reporting_create',
  PROJECT_REPORTING_UPDATE: 'project_reporting_update',
  PROJECT_REPORTING_DELETE: 'project_reporting_delete',
  PROJECT_REPORTING_PUBLISHED: 'project_reporting_published',
  PROJECT_REPORTING_HISTORIE_TRANSACTION: 'project_reporting_history_transaction',
  PROJECT_REPORTING_DEPOSIT: 'project_reporting_deposits',
  
  VIEW_PUBLICATION: 'publication_view',
  CREATE_PUBLICATION: 'publication_create',
  UPDATE_PUBLICATION: 'publication_update',
  DELETE_PUBLICATION: 'publication_delete',
  FILES_PUBLICATION: 'publication_files',
  DOWNLOAD_FILES: 'publication_downloads_files',
  VIEW_COMMENT: 'comment_view',

  VIEW_CHAT: 'chat_view',
  VIEW_MAIL: '',

  VIEW_PROSPECT : 'view_prospect',
  VALIDATE_PROSPECT  : 'validate_prospect',
  REJECT_PROSPECT : 'reject_prospect',

  VIEW_FORMALITIES_PARAMETERS: 'view_formalities_parameters',
  EDIT_FORMALITIES_PARAMETERS: 'edit_formalities_parameters',

  ADD_PROJECT_FORMALITIES: 'add_project_formalities',
  VIEW_PROJECT_FORMALITIES: 'view_project_formalities',
  EDIT_PROJECT_FORMALITIES: 'edit_project_formalities',
  DELETE_PROJECT_FORMALITIES: 'delete_project_formalities',


  CAN_MODERATE : "can_moderate",
  CAN_SCAN : "can_scan",
  CAN_PARTICIPATE : "can_participate",
  CAN_PRESENT : "can_present",
  CAN_SELL_TICKET : "can_sell_ticket",
  CAN_SCAN_TICKET : "can_scan_ticket",

  CAN_VIEW_ATELIER : "atelier_view",
  CAN_CREATE_ATELIER : "atelier_create",
  CAN_UPDATE_ATELIER : "atelier_update",
  CAN_DELETE_ATELIER : "atelier_delete",
  CAN_VIEW_ALL_ATELIER : "atelier_view_all",
  CAN_ADD_PARTICIPANT_TO_ATELIER : "atelier_add_participant",
  CAN_VIEW_EVENT : "event_view",
  CAN_CREATE_EVENT : "event_create",
  CAN_UPDATE_EVENT : "event_update",
  CAN_DELETE_EVENT : "event_delete",
  CAN_VIEW_ALL_EVENT : "event_view_all",

  CAN_ADD_PARTICIPANT_TO_EVENT : "event_add_participant",
  CAN_VIEW_EVENT_PARTICIPANT : "event_add_participant",
  CAN_VIEW_EVENT_ALL_PARTICIPANT : "event_add_participant",
  CAN_UPDATE_EVENT_PARTICIPANT : "event_add_participant",
  CAN_UPDATE_EVENT_PARTICIPANT_STATUS : "event_add_participant",

  CAN_ADD_SUBSCRIPTOR_TO_EVENT : "event_add_participant",
  CAN_VIEW_EVENT_SUBSCRIPTOR : "event_add_participant",
  CAN_VIEW_EVENT_ALL_SUBSCRIPTOR : "event_add_participant",
  CAN_APPROVE_EVENT_SUBSCRIPTOR : "event_add_participant",
  CAN_REJECT_EVENT_SUBSCRIPTOR : "event_add_participant",

  CAN_SEND_EVENT_INVITATAION : "event_send_invitation",
  CAN_IMPORT_EVENT_PARTICIPANT : "event_import_participant",
  CAN_EXPORT_EVENT_PARTICIPANT : "event_export_participant",

  CAN_VIEW_EVENT_FORM : "event_view",
  CAN_CREATE_EVENT_FORM : "event_create",
  CAN_UPDATE_EVENT_FORM : "event_update",
  CAN_DELETE_EVENT_FORM : "event_delete",
  CAN_VIEW_ALL_EVENT_FORM : "event_view_all",

  CAN_CREATE_PARTICPANT_STATUT: "status_create",

  VIEW_EVENT_PARTICIPATORS: '',
  DELETE_PARTICIPATOR: '',
  DELETE_ALL_PARTICIPATOR: '',

  CAN_VIEW_EVENT_STATUS : "status_view",
  CAN_CREATE_EVENT_STATUS : "status_create",
  CAN_UPDATE_EVENT_STATUS : "status_update",
  CAN_DELETE_EVENT_STATUS : "status_delete",

  //QVCT
  CAN_QVCT_SURVEY_CATEGORY_VIEW: 'view_qvct_survey_category',


    //Access Module

    CAN_VIEW_ACCESS_CONFIG : 'config_view',
    CAN_CREATE_ACCESS_CONFIG : 'config_create',
    CAN_UPDATE_ACCESS_CONFIG : 'config_update',
    CAN_DELETE_ACCESS_CONFIG : 'config_delete',

    CAN_VIEW_ACCESS_HISTORICS : 'access_history_view',

    CAN_CARD_CONFIG_VIEW : 'card_config_view',
    CAN_CARD_CONFIG_CREATE : 'card_config_create',
    CAN_CARD_CONFIG_UPDATE : 'card_config_update',
    CAN_CARD_CONFIG_DELETE : 'card_config_delete',
    CAN_CARD_CONFIG_ASSIGN : 'card_config_assign',
    CAN_CARD_CONFIG_UNASSIGN : 'card_config_unassign',
    CAN_CARD_CONFIG_STATUS_CHANGE : 'card_config_status',
    CAN_CARD_CONFIG_HISTORY_VIEW : 'card_config_history',
    CAN_CARD_CONFIGURE: 'card_config_configure',

    CAN_CREATE_PERIMETER : 'perimeter_create',
    CAN_VIEW_PERIMETER : 'perimeter_view',
    CAN_UPDATE_PERIMETER : 'perimeter_update',
    CAN_DELETE_PERIMETER : 'perimeter_delete',
    CAN_IMPORT_PERIMETER : 'perimeter_import',

    CAN_CREATE_DOOR : 'door_create',
    CAN_VIEW_DOOR : 'door_view',
    CAN_UPDATE_DOOR : 'door_update',
    CAN_DELETE_DOOR : 'door_delete',
    CAN_IMPORT_DOOR : 'door_import',

    CAN_VIEW_STOCK_STATUS : 'can_view_stock_status',
    CAN_DOWNLOAD_STOCK_STATUS : 'can_download_stock_status',

    CAN_VIEW_LICENSE : 'view_license_list',
    CAN_VIEW_LICENSE_CONFIG : 'view_license_config',
    CAN_CREATE_LICENSE_CONFIG : 'create_license_config',
    CAN_UPDATE_LICENSE_CONFIG : 'update_license_config',
    CAN_DELETE_LICENSE_CONFIG : 'delete_license_config',

    CAN_VIEW_SESSION_LIST : 'sales_session_view'

}
